import axios from '@/api/config';

const integralRule = {
  getIntegralRuleById(data) {
    return axios.get(`${process.env.BASE_URL}/integralRule/getIntegralRuleById/` + data, {});
  },
  getIntegralRuleDetail(data) {
    return axios.get(`${process.env.BASE_URL}/integralRule/getIntegralRuleDetail`, {params: data});
  },
  getIntegralRule(data) {
    return axios.get(`${process.env.BASE_URL}/integralRule/getIntegralRule`, {params: data});
  },
  getIntegralRuleList(data) {
    return axios.get(`${process.env.BASE_URL}/integralRule/getIntegralRuleList`, {params: data});
  },
  getIntegralRuleTree(data) {
    return axios.get(`${process.env.BASE_URL}/integralRule/getIntegralRuleTree`, {params: data});
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/integralRule/pageList`, data);
  },
  addIntegralRule(data) {
    return axios.post(`${process.env.BASE_URL}/integralRule/addIntegralRule`, data);
  },
  updateIntegralRule(data) {
    return axios.put(`${process.env.BASE_URL}/integralRule/updateIntegralRule`, data);
  },
  deleteIntegralRule(data) {
    return axios.delete(`${process.env.BASE_URL}/integralRule/deleteIntegralRule`,  {data: data});
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/integralRule/exportExcel`, {params: data});
  },
  importData(data) {
    return axios.post(`${process.env.BASE_URL}/integralRule/importData`, data);
  },
  active(data) {
    return axios.post(`${process.env.BASE_URL}/integralRule/active`, data);
  },
}

export default integralRule;



// WEBPACK FOOTER //
// ./src/api/integralRule.js